import React from "react";
import { Link } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";

const MemberForm = ({
  memberData,
  isLoading,
  isSeasonOpenForRegistration = false,
}) => {
  console.log("MemberForm - memberData:", memberData);
  // Log each member's id to verify it's from API response
  if (memberData && Array.isArray(memberData)) {
    memberData.forEach((member, idx) => {
      console.log(`Member ${idx} - id:`, member.id, "full object:", member);
    });
  }

  if (isLoading) {
    return (
      <div
        className="members-loading"
        style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 240 }}
      >
        <ThreeDots height="80" width="80" radius="9" color="#4fa94d" ariaLabel="three-dots-loading" visible={true} />
      </div>
    );
  }

  if (!Array.isArray(memberData) || memberData.length === 0) {
    return <p>No members found</p>;
  }

  return (
    <div className="member-section">
      <style>
        {`
          .view-profile-btn {
            padding: 10px 15px;
            border-radius: 100px;
            display: inline-block;
            font-size: 14px;
            text-align: center;
            text-decoration: none;
            line-height: inherit;
            font-weight: 500;
            min-width: 80px;
            border: solid 1px #ccc;
          }
          .view-profile-btn:not(.view-profile-btn--purple) {
            background: #fff;
            color: #333 !important;
          }
          .view-profile-btn:hover {
            background: #333;
            color: #fff !important;
            border-color: #333;
          }
          .view-profile-btn--purple {
            background: #b38ec1 !important;
            color: #fff !important;
            border-color: #b38ec1;
          }
          .view-profile-btn--purple:hover {
            background: #a17dad !important;
            color: #fff !important;
            border-color: #a17dad;
          }
          .member-card-box {
            box-shadow: 0 4px 12px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.08);
            min-height: 285px;
            padding: 12px;
          }
          .member-card-box .playerINfotitle,
          .member-card-box p,
          .member-card-box h3 {
            color: #333 !important;
          }
          .member-card-box .playerINfotitle {
            color: #7a9234 !important;
          }
            div.member-section{
            min-height: 180px !important;
            height: calc(100vh - 410px);
            margin-bottom: 50px;
            padding: 30px 20px 0 20px;
            overflow-y: auto;
            overflow-x: hidden;
            }
            body {
               overflow-y: hidden;
            }
                       

            @media (max-width: 1024px) {              
             body {
               overflow-y: auto;
            }
            
        `}
      </style>
      <div className="row">
        {memberData?.map((member, index) => {
          const hasPaidForSeason =
            member?.hasPaidForOpenSeason ??
            member?.paymentDone ??
            member?.hasPaidForSeason ??
            member?.paid_for_season ??
            false;
          const showPurpleViewProfile = hasPaidForSeason;
          return (
            <div
              key={member.id || index}
              className="col-xl-3 col-lg-4 col-sm-6 mb-5"
            >
              <div className="player-info members-listing-desc memberBox-bg w-100 h-100 flu-box shadow member-card-box">
                <div className="clear"></div>
                <div className="subsection p1">
                  <div className="flu-box">
                    <div className="left">
                      <table className="show-profile-info">
                        <tbody>
                          <tr>
                            <td className="profile-img text-center">
                              {/* <img
                                             src={member?.image ? (member.image.startsWith("/") ? member.image : "/" + member.image) : "/default.png"}
                                             alt="Profile"
                                          /> */}

                              <img
                                src={
                                  member?.icon
                                    ? member.icon.startsWith("/")
                                      ? member.icon
                                      : "/" + member.icon
                                    : "/default.png"
                                }
                                alt="Profile"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td
                              align="center"
                              style={{
                                padding: "9px 0px",
                                textAlign: "center",
                              }}
                            >
                              <div className="buttonwrapper">
                                <Link
                                  to={`/carter/profile?userId=${member.id}`}
                                  className={
                                    showPurpleViewProfile
                                      ? "view-profile-btn view-profile-btn--purple"
                                      : "view-profile-btn"
                                  }
                                >
                                  View Profile
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h2
                                className="playerINfotitle"
                                title={member?.fullName || "Player"}
                              >
                                {member?.fullName || member?.playername}
                              </h2>
                            </td>
                          </tr>
                          <tr>
                            <td align="center">
                              <h3>
                                &nbsp;
                                {member?.playerLevel ||
                                  member?.player_level}{" "}
                                Rating
                              </h3>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p
                      className="overflowText"
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Home Court: {member?.home_court || member?.name}
                    </p>
                    {/* <p>Season Record: <Link to="/carter/members/record" className="green">{member.current_wins}-{member.current_losses}</Link></p> */}
                    <p>
                      Season Record:{" "}
                      <Link
                        to={`/carter/members/record`}
                        className="green"
                        state={{ memberId: member.id, recordType: "tournament" }}
                      >
                        {member?.currentWins ?? member?.current_wins ?? 0}-
                        {member?.currentLosses ?? member?.current_losses ?? 0}
                      </Link>
                    </p>
                    <p className="msg-link-btn">
                      <Link
                        to={`/carter/schedule?userId=${member?.id || member?.userId || ""}${(() => {
                          const seasonId =
                            member?.current_season ??
                            member?.currentSeason ??
                            member?.season_id ??
                            member?.seasonId;
                          return seasonId ? `&seasonId=${seasonId}` : "";
                        })()}`}
                        className="msg-link"
                      >
                        Schedule
                      </Link>
                    </p>

                    <p className="msg-link-btn">
                      <Link
                        to={`/carter/sendMessage?userId=${member.id}`}
                        state={{ recipientName: member?.fullName || member?.playername || "" }}
                        className="msg-link ie-post-link"
                      >
                        Message
                      </Link>
                    </p>
                    <p className="pt-2 mb-0" style={{ clear: "both" }}>
                      Best Results:{" "}
                      <span className="green">
                        {member?.best_result && member.best_result != 0
                          ? member.best_result
                          : "N/A"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MemberForm;
